import { call, put, takeEvery } from "redux-saga/effects";
import { kienThucApi } from "../../../api/category/kienThucApi";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IKienThuc } from "../../../model/respone/category/IKienThuc";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eChuongTrinhDaoTaoKienThucIds, IChuongTrinhDaoTaoKienThucActionTypes } from "../../action-types/ctdt/IChuongTrinhDaoTaoKienThucActions";
import { rootActions } from "../../actions/rootActions";
const mainAction =rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTaoKienThuc;
export function* chuongTrinhDaoTaoKienThucSaga(): any {
  yield takeEvery(eChuongTrinhDaoTaoKienThucIds.LOAD_START, loadWorker);
  yield takeEvery(eChuongTrinhDaoTaoKienThucIds.SAVE_START, saveWorker);
  yield takeEvery(eChuongTrinhDaoTaoKienThucIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(kienThucApi.SelectAll);
  if (res.is_success) {
    yield put(
      rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTaoKienThuc.LOAD_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTaoKienThuc.LOAD_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* saveWorker(action: IChuongTrinhDaoTaoKienThucActionTypes): any {
  let res: IBaseRespone = yield call(kienThucApi.SelectAll);
  const payload = action.payload as IKienThuc;
  if (payload.id_kien_thuc > 0) {
    res = yield call(kienThucApi.Update, payload);
  } else {
    res = yield call(kienThucApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IChuongTrinhDaoTaoKienThucActionTypes): any {
  const res: IBaseRespone = yield call(
    kienThucApi.Delete,
    action.payload as IIdsRequest
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
